import './index.scss';
import { animationOptions } from './animationlist.js';
import  ResetAttributes  from '../../../general/ResetButton.js'
import { __ } from '@wordpress/i18n';
import classnames from 'classnames';
import { useState, useEffect } from '@wordpress/element';
import { addFilter } from '@wordpress/hooks';
import {
	InspectorControls,
} from '@wordpress/block-editor';
import {
	PanelBody,
	SelectControl,
	CheckboxControl,
	RangeControl,
	ToggleControl,
  Modal, 
  Button,
	Flex, FlexItem
} from '@wordpress/components';

const allowedBlocks = ['core/group'];



const addAttributes = (settings, name) => {
	if (!allowedBlocks.includes(name)) return settings;

	if (typeof settings.attributes !== 'undefined') {
		settings.attributes = {
			...settings.attributes,
			aanimation: {
				type: 'object',
				default: {
					aOn: false,
					name: '',
					isCustom: false, // true = inline style, false = CSS class
					all: '', // shorthand string like "hinge 1.2s linear none infinite 0s"
				},
			},
		};
	}
	return settings;
};


const addInspectorControl = (BlockEdit) => (props) => {
	if (!allowedBlocks.includes(props.name)) return <BlockEdit {...props} />;

	const { attributes, setAttributes, isSelected } = props;
	const { aanimation = {} } = attributes;
	const { aOn, name, isCustom, all } = aanimation;

	const defaultPosition = {
		aOn: false,
		name: '',
		isCustom: false, // true = inline style, false = CSS class
		all: '',
	};

	const isDifferentFromDefault = JSON.stringify({ ...aanimation, aOn: undefined }) !== JSON.stringify({ ...defaultPosition, aOn: undefined });

		
	const [duration, setDuration] = useState(1);
	const [timing, setTiming] = useState('linear');
  const [fillMode, setFillMode] = useState('');
  const [count, setCount] = useState(1);   
  const [infinite, setInfinite] = useState(true);	
	const [delay, setDelay] = useState(0);	

  


	useEffect(() => {
		if (all && typeof all === 'string') {
			const parts = all.trim().split(/\s+/);
			const [_name, _duration, _timing, _fillMode, _count, _delay] = parts;     

			if (_duration?.endsWith('s')) setDuration(parseFloat(_duration));
			if (_timing) setTiming(_timing);
			if (_delay?.endsWith('s')) setDelay(parseFloat(_delay));
			if (_fillMode && _fillMode !== 'none') setFillMode(_fillMode);
			if (_count && _count !== 'infinite') {
				setCount(parseInt(_count));
				setInfinite(false);
			} else {
				setInfinite(true);
			}
		}
	}, [all]);


	
	useEffect(() => {
		if (!aOn || !name) return;
		const countString = infinite ? 'infinite' : count.toString();
		const newAll = `${name} ${duration}s ${timing} ${fillMode || 'none'} ${countString} ${delay}s`.trim();
		if (newAll !== all) {
			setAttributes({
				aanimation: { ...aanimation, all: newAll },
			});
		}		
	}, [aOn, name, duration, timing, fillMode, count, infinite, delay]);

	return (
		<>
			<BlockEdit {...props} />
			{isSelected && (
				<InspectorControls group="settings">
					<PanelBody title={__('Animation', 'aver')} initialOpen={aOn}>

						<Flex>
							<FlexItem>
								<ToggleControl
									label={__('Enable Animation', 'aver')}
									checked={!!aOn}
									onChange={(newval) =>
										setAttributes({
											aanimation: { ...aanimation, aOn: !!newval },
										})
									}
								/>
							</FlexItem>
							<FlexItem>
								{ isDifferentFromDefault  && (
									<ResetAttributes
										onConfirm={() => {
											setAttributes({
												aanimation: {
													aOn: false,
													name: '',
													isCustom: false,
													all: '',
												},
											});
											setDuration(1);
											setTiming('linear');
											setDelay(0);
											setFillMode('');
											setInfinite(true);
											setCount(1);
										}}
									/>
								)}
							</FlexItem>
						</Flex>
		

						{aOn && (
							<>
								<SelectControl
									label={__('Animation Name', 'aver')}
									options={animationOptions}
									value={name}
									onChange={(newval) =>
										setAttributes({
											aanimation: { ...aanimation, name: newval },
										})
									}
								/>

								<CheckboxControl
									label={__('Use Inline Animation (Custom Keyframe)', 'aver')}
									checked={!!isCustom}
									onChange={(newval) =>
										setAttributes({
											aanimation: { ...aanimation, isCustom: !!newval },
										})
									}
									help={
										isCustom
											? __('Applies animation via inline CSS style', 'aver')
											: __('Applies animation via CSS class name', 'aver')
									}
								/>

								{isCustom && (
									<>
										<RangeControl
											label={__('Duration (s)', 'aver')}
											value={duration}
											min={0.1}
											max={10}
											step={0.1}
											onChange={setDuration}
										/>

										<SelectControl
											label={__('Timing Function', 'aver')}
											options={[
												{ label: 'Ease', value: 'ease' },
												{ label: 'Linear', value: 'linear' },
												{ label: 'Ease-in-out', value: 'ease-in-out' },
											]}
											value={timing}
											onChange={setTiming}
										/>

										<RangeControl
											label={__('Delay (s)', 'aver')}
											value={delay}
											min={0}
											max={10}
											step={0.1}
											onChange={setDelay}
										/>

										<CheckboxControl
											label={__('Infinite Loop', 'aver')}
											checked={!!infinite}
											onChange={(newval) => {
												setInfinite(!!newval);
												if (!newval && count === 0) setCount(1);
											}}
										/>

										{!infinite && (
											<RangeControl
												label={__('Iteration Count', 'aver')}
												value={count}
												min={1}
												max={50}
												step={1}
												onChange={setCount}
											/>
										)}

										<SelectControl
											label={__('Fill Mode', 'aver')}
											options={[
												{ label: 'None', value: '' },
												{ label: 'Forwards', value: 'forwards' },
												{ label: 'Backwards', value: 'backwards' },
												{ label: 'Both', value: 'both' },
											]}
											value={fillMode}
											onChange={setFillMode}
										/>			
									</>									
								)}

							</>
						)}

					</PanelBody>
				</InspectorControls>
			)}
		</>
	);
};


const applyExtraClassEditor = (BlockListBlock) => (props) => {
	if (!allowedBlocks.includes(props.name)) return <BlockListBlock {...props} />;

	const {
		attributes: { aanimation = {} },
		className,
		wrapperProps,
	} = props;
	const { aOn, name, isCustom, all } = aanimation;

	if (!aOn) return <BlockListBlock {...props} />;

	// Inline animation style (custom)
	const cssstyle = {
		...wrapperProps?.style,
		...(name && isCustom && all ? { animation: all } : {}),
	};

	// CSS class-based animation
	const classes = classnames(className, {
		[name]: !!name && !isCustom, // only add class when not custom
		ani: !!name,
		anishow: !!name,
	});

	return (
		<BlockListBlock
			{...props}
			wrapperProps={{ style: cssstyle }}
			className={classes}
		/>
	);
};

/**
 * Filters
 */
addFilter('blocks.registerBlockType', 'aver/aanimation-attributes', addAttributes);
addFilter('editor.BlockEdit', 'aver/aanimation-inspector-control', addInspectorControl);
addFilter('editor.BlockListBlock', 'aver/aanimation-editor-class', applyExtraClassEditor);

export default {};
